import * as Service from '../coupon-services';

export default {};
